
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/start-a-travel-blog",
      function () {
        return require("private-next-pages/start-a-travel-blog.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/start-a-travel-blog"])
      });
    }
  